
import React, { useState, useEffect } from "react";
import LoadingIndicator from "../components/LoadingIndicator";

const Loader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading delay (e.g., fetching data)
    const timer = setTimeout(() => setIsLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="container mt-6">
        <div className="card">
            <div className="card-header">
                {isLoading ? (
                    <LoadingIndicator message="Please wait while we load the data..." />
                ) : (
                <h3 className="h5">Welcome to the App!</h3>
                )}
            </div>
            <div className="card-block">
              
            </div>
        </div>
    </div>
  );
};

export default Loader;
